import { Dialog } from "primereact/dialog";
import React, { useState, useEffect } from "react";
import DateRange from "./dateRange";

export default function DateRangePopUp({
  show,
  setShow,
  date,
  setDate,
  setSelectOption,
  lastSelected,
}) {
  const [isMobile, setIsMobile] = useState(false);
  
  // Check if the screen is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Common breakpoint for mobile
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  
  const closeModal = () => {
    setShow(false);
    setSelectOption(lastSelected);
  };
  
  return (
    <div>
      <Dialog
        header={"Select Date Range"}
        visible={show}
        style={{ width: "auto" }}
        onHide={closeModal}
        position={isMobile ? "right" : "center"} 
        modal={!isMobile} 
        draggable={false}
        resizable={false}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <DateRange
            date={date}
            setDate={(e) => {
              setDate(e);
            }}
            cancel={closeModal}
          />
        </div>
      </Dialog>
    </div>
  );
}